import apiService from "./apiService";
import AppConstants from "../appConstants";

class ClientSignatureService {
    getAllClientSignature(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_SIGNATURE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getClientSignatureDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CLIENT_SIGNATURE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerClientSignature(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CLIENT_SIGNATURE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteClientSignature(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CLIENT_SIGNATURE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CLIENT_SIGNATURE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateApiCache(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_SIGNATURE_API_CACHE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    sync(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENT_SIGNATURE_SYNC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ClientSignatureService();
